import type {
  NotificationsDatabaseQueryKey,
  NotificationsDatabaseQuerySuffix,
} from "./notifications-database.type";

import { useQueryClient } from "@tanstack/react-query";

export const useInvalidateNotificationsDatabase = () => {
  const queryClient = useQueryClient();

  const invalidateNotifications = (
    queries: "*" | NotificationsDatabaseQuerySuffix[]
  ) => {
    if (queries === "*") {
      const queryKey: NotificationsDatabaseQueryKey = ["notifications"];
      return queryClient.invalidateQueries({ queryKey });
    }

    queries.forEach((query) => {
      const queryKey: NotificationsDatabaseQueryKey = ["notifications", query];
      queryClient.invalidateQueries({ queryKey });
    });
  };

  return {
    invalidateNotifications,
  };
};
